/**
 * @generated SignedSource<<a6e295fade9c945a365e706d29c98cbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PermissionsRuleFragment$data = {
  readonly permissionPropose: boolean;
  readonly permissionSign: boolean;
  readonly permissionVote: boolean;
  readonly " $fragmentType": "PermissionsRuleFragment";
};
export type PermissionsRuleFragment$key = {
  readonly " $data"?: PermissionsRuleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PermissionsRuleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PermissionsRuleFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionVote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionSign",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionPropose",
      "storageKey": null
    }
  ],
  "type": "LiquidDelegationRules",
  "abstractKey": null
};

(node as any).hash = "821dbfe33581099e787f987d3e4186aa";

export default node;
